import { useFormApi } from 'informed';
import { ApplicationData } from '../../../../types/TymbeApi';
import { AttendanceResolution } from '@tymbe/schema/enums';
import UnapprovedAttendanceRow from './UnapprovedAttendanceRow';
import { BadgePill } from '@tymbe/ty-components/indicators';
import Spinner from '@tymbe/ty-components/indicators/Spinner';

type ShiftAttendanceProps = {
  applications: ApplicationData[];
  startDate: string;
  endDate: string;
  onSubmit: (values: AttendanceScope[]) => Promise<unknown> | void;
  isLoading?: boolean;
};

export type AttendanceScope = {
  id: number;
  confirmed_time: number;
  break: number;
  start: number;
  end: number;
  rating: number;
  selected: boolean;
  resolution: AttendanceResolution;
};

export type FormValues = {
  applications: AttendanceScope[];
};

const ShiftUnapprovedAttendance = ({
  applications,
  startDate,
  endDate,
  onSubmit,
  isLoading = false,
}: ShiftAttendanceProps) => {
  const formApi = useFormApi();

  const submitSingle = async (key: number) => {
    const values: AttendanceScope = formApi?.getValue(`applications.${key}`);
    if (!values) return;
    try {
      await onSubmit([values]);
    } catch {
      /* can be safely ignored */
    }
  };

  return (
    <>
      <div className="grid grid-cols-1 grid-rows-[60px,1fr] overflow-x-auto">
        <div className="text-body-2-xl font-normal grid grid-cols-[minmax(250px,1fr)_110px_110px_160px_minmax(300px,1fr)] grid-rows-1 row-start-1 row-span-1">
          <div className="flex items-center gap-2 col-start-1">
            <span className="text-secondary-600 font-semibold">
              Docházka k potvrzení
            </span>
            <BadgePill variant="info">{applications.length}</BadgePill>
          </div>
          {applications.length !== 0 && (
            <>
              <div className="col-start-2 flex">
                <span className="my-auto">Odpracováno</span>
              </div>
              <div className="col-start-3 flex">
                <span className="my-auto">Přestávka</span>
              </div>
              <div className="col-start-4 flex">
                <span className="my-auto">Příchod a odchod</span>
              </div>
            </>
          )}
        </div>

        {applications.length ? (
          <div className="grid rounded-2xl grid-cols-[minmax(250px,1fr)_110px_110px_160px_minmax(300px,1fr)] grid-rows-1 row-start-2 row-span-1">
            {applications.map((application, index) => (
              <>
                {index > 0 && (
                  <hr className="col-span-full border-secondary-transparent-10" />
                )}
                <div
                  className={`p-4 grid col-span-full grid-cols-subgrid border-secondary-transparent-10 ${
                    index === 0
                      ? applications.length === 1
                        ? 'border rounded-2xl'
                        : 'border-t border-l border-r rounded-t-2xl'
                      : index === applications.length - 1
                      ? 'border-b border-l border-r rounded-b-2xl'
                      : 'border-l border-r'
                  }`}
                >
                  <UnapprovedAttendanceRow
                    key={application.id}
                    application={application}
                    submitSingle={submitSingle}
                    startDate={startDate}
                    endDate={endDate}
                  />
                </div>
              </>
            ))}
          </div>
        ) : null}
      </div>

      {isLoading && <Spinner color="secondary-600" className="w-5 h-5" />}
    </>
  );
};

export default ShiftUnapprovedAttendance;
